import PropTypes from "prop-types";

import { useRouter } from "hooks";
import { Contentful } from "pages";
import LegalLayout from "layouts/LegalLayout";

import { Root, StyledPlaceholder } from "./styles";

const LegalPage = ({ page }) => {
  const {
    camelizedQuery: { lang },
  } = useRouter();

  return (
    <Root>
      <LegalLayout>
        <Contentful page={page} lang={lang} loader={<StyledPlaceholder variant="rect" />} />
      </LegalLayout>
    </Root>
  );
};

LegalPage.propTypes = {
  page: PropTypes.string.isRequired,
};

export default LegalPage;
